export default {
  props: {
    visible: {
      required: true,
      default: false
    }
  },
  data () {
    return {
      isVisible: this.visible
    }
  },
  watch: {
    visible (value) {
      this.isVisible = value
    },
    isVisible (value) {
      this.$emit('update:visible', value)
    }
  },
  methods: {
    _hide () {
      this.isVisible = false
    }
  }
}

